import { useContext } from 'react';

import type { MovementInfo } from 'src/app/pages/movement/shared/api';
import { MovementContext } from 'src/app/pages/movement/shared/context';

export function useMovementContext(): MovementInfo {
	const movementContext = useContext(MovementContext);

	if (!movementContext) {
		throw new Error('MovementInfo was not set');
	}

	return movementContext;
}
